module.exports = __webpack_public_path__ + "media/images/call-1743a76e18d76b1ce4e4f449e109327f.png";